import CallBackTypes from "./callBack.types";

//***************FETCH CALLBACK START**************************/
export const callbackFetchAllStart = (callbackList: any) => ({
  type: CallBackTypes.CALLBACK_FETCH_START,
  payload: callbackList,
});
export const callbackFetchAllSuccess = (success: any) => ({
  type: CallBackTypes.CALLBACK_FETCH_SUCCESS,
  payload: success,
});
export const callbackFetchAllFailure = (failure: any) => ({
  type: CallBackTypes.CALLBACK_FETCH_FAILURE,
  payload: failure,
});
export const callbackFetchAllReset = () => ({
  type: CallBackTypes.CALLBACK_FETCH_RESET_START,
});
export const callbackFetchAllChanged = () => ({
  type: CallBackTypes.CALLBACK_FETCH_CHANGED,
});
//***************FETCH CALLBACK END**************************/

//*******EXPORT CALL BACK START********* */
export const callbackExportAllStart = (callbackList: any) => ({
  type: CallBackTypes.CALLBACK_EXPORT_START,
  payload: callbackList,
});
export const callbackExportAllSuccess = (success: any) => ({
  type: CallBackTypes.CALLBACK_EXPORT_SUCCESS,
  payload: success,
});
export const callbackExportAllFailure = (failure: any) => ({
  type: CallBackTypes.CALLBACK_EXPORT_FAILURE,
  payload: failure,
});
export const callbackExportAllReset = () => ({
  type: CallBackTypes.CALLBACK_EXPORT_CHANGED,
});
export const callbackExportAllChanged = () => ({
  type: CallBackTypes.CALLBACK_EXPORT_RESET_START,
});
//*******EXPORT CALL BACK END*************** */
